import React, { useEffect, useState } from 'react';
import CenterModal from '../CenterModalWindow/CenterModalWindow';
import ButtonPill from '../Buttons/button-pills';
import {
  clampPrintMarginInches,
  normalizeCustomPrintMarginsIn,
} from './textEditorPrintLayout';

const FIELD_DEFS = [
  { key: 'top', label: 'Top (in)' },
  { key: 'right', label: 'Right (in)' },
  { key: 'bottom', label: 'Bottom (in)' },
  { key: 'left', label: 'Left (in)' },
];

export default function TextEditorPrintMarginsModal({
  isOpen,
  onClose,
  initialMarginsIn,
  onApply,
}) {
  const [draft, setDraft] = useState(() => normalizeCustomPrintMarginsIn(initialMarginsIn));

  useEffect(() => {
    if (isOpen) {
      setDraft(normalizeCustomPrintMarginsIn(initialMarginsIn));
    }
  }, [isOpen, initialMarginsIn]);

  const handleChange = (key, value) => {
    setDraft((prev) => ({
      ...prev,
      [key]: clampPrintMarginInches(value, prev[key]),
    }));
  };

  const handleApply = () => {
    onApply(normalizeCustomPrintMarginsIn(draft));
    onClose();
  };

  return (
    <CenterModal
      isOpen={isOpen}
      onClose={onClose}
      width="fit-content"
      height="auto"
      overlayClassName="wfm-text-editor__modal-overlay"
      contentClassName="wfm-text-editor__modal wfm-text-editor__print-margins-modal"
    >
      <div className="wfm-text-editor__print-margins-modal-inner">
        <h3 className="wfm-text-editor__print-margins-modal-title">Custom print margins</h3>
        <p className="wfm-text-editor__print-margins-modal-hint">
        Set margins in inches (0.25–2). Paginated layout may increase the bottom margin slightly for
        </p>
        <div className="wfm-text-editor__print-margins-modal-grid">
        {FIELD_DEFS.map(({ key, label }) => (
          <label key={key} className="wfm-text-editor__print-margins-field">
            <span>{label}</span>
            <input
              type="number"
              min="0.25"
              max="2"
              step="0.05"
              value={draft[key]}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          </label>
        ))}
        </div>
        <div className="wfm-text-editor__print-margins-modal-actions">
        <ButtonPill type="button" variant="outline" color="gray" size="sm" onClick={onClose}>
          Cancel
        </ButtonPill>
        <ButtonPill type="button" variant="solid" color="brand" size="sm" onClick={handleApply}>
          Apply
        </ButtonPill>
        </div>
      </div>
    </CenterModal>
  );
}
